export const SupportedEnvironments = {
  DEV: 'development',
  SIT: 'staging',
  PROD: 'production',
} as const;

export type SupportedEnvironments =
  (typeof SupportedEnvironments)[keyof typeof SupportedEnvironments];
